import Button from '@datacamp/waffles-button';
import { CheckmarkIcon, CrossIcon } from '@datacamp/waffles-icons';
import { colors } from '@datacamp/waffles-tokens';
import React from 'react';
import { useTranslation } from '../useTranslation';

var getDataTrackId = function getDataTrackId(messageType) {
  var defaultDataTrackId = {
    no: 'rating-no',
    yes: 'rating-yes'
  };

  if (!messageType) {
    return defaultDataTrackId;
  }

  switch (messageType) {
    case 'ASSISTANT':
      return {
        no: 'ai-assistant-rating-no',
        yes: 'ai-assistant-rating-yes'
      };

    case 'INCORRECT':
      return {
        no: 'ai-incorrect-no',
        yes: 'ai-incorrect-yes'
      };

    case 'HINT':
    case 'CORRECT':
    case 'SOLUTION':
    default:
      return defaultDataTrackId;
  }
};

var RateFeedbackQuestion = function RateFeedbackQuestion(_ref) {
  var messageType = _ref.messageType,
      onRateNotUseful = _ref.onRateNotUseful,
      onRateUseful = _ref.onRateUseful,
      question = _ref.question;
  var dataTrackId = getDataTrackId(messageType);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  return /*#__PURE__*/React.createElement("div", {
    style: {
      alignItems: 'center',
      display: 'flex',
      flexGrow: 1,
      justifyContent: 'space-between'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      margin: 'none'
    }
  }, question), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
    ariaLabel: t('RateFeedbackQuestion.yes'),
    css: {
      border: 'none'
    },
    dataAttributes: {
      trackid: dataTrackId.yes
    },
    onClick: onRateUseful,
    size: "small"
  }, /*#__PURE__*/React.createElement(CheckmarkIcon, null), t('RateFeedbackQuestion.yes')), /*#__PURE__*/React.createElement(Button, {
    ariaLabel: t('RateFeedbackQuestion.no'),
    css: {
      border: 'none'
    },
    dataAttributes: {
      trackid: dataTrackId.no
    },
    onClick: onRateNotUseful,
    size: "small"
  }, /*#__PURE__*/React.createElement(CrossIcon, {
    color: colors.red
  }), t('RateFeedbackQuestion.no'))));
};

export default RateFeedbackQuestion;